import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import html2pdf from "html2pdf.js";
import config from "../../config";
import JsBarcode from "jsbarcode";

const Movein_label = () => {
  const { shipment_id } = useParams();
  const hasGenerated = React.useRef(false); // prevent double run

  let userDetail = localStorage.getItem("ship_rocket_user");
  let userData = userDetail ? JSON.parse(userDetail) : {};

  React.useEffect(() => {
    if (!hasGenerated.current) {
      hasGenerated.current = true;
      fetchShipment();
    }
  }, []);

  const fetchShipment = async () => {
    try {
      const res = await axios.post(
        config.apiUrl + "/shipment/print_b2b_label_shipments",
        {
          //   customer_id: userData.customer_id,
          shipment_id: shipment_id,
        },
        { headers: config.headers }
      );

      generatePDF(res.data.output);
    } catch (err) {
      console.log(err);
    }
  };

  const generatePDF = (shipments) => {
    const wrapper = document.createElement("div");
    wrapper.style.width = "4in";
    wrapper.style.margin = "0 auto";
    wrapper.style.background = "#ffffff";
    wrapper.style.padding = "0";

    let htmlContent = "";

    shipments.forEach((sub) => {
      const barcodes = sub.barcodeList || [];
      const totalPkgs = barcodes.length || 1;

      // Create a flat array of boxes based on quantity
      const expandedBoxes = [];
      if (sub.boxes && sub.boxes.length > 0) {
        sub.boxes.forEach((box) => {
          const qty = box.quantity || 1;
          for (let i = 0; i < qty; i++) {
            expandedBoxes.push({
              box_length: box.box_length || 0,
              box_width: box.box_width || 0,
              box_height: box.box_height || 0,
              box_weight: box.box_weight || 0,
            });
          }
        });
      }

      barcodes.forEach((barcode, index) => {
        const canvas = document.createElement("canvas");
        JsBarcode(canvas, barcode, {
          format: "CODE128",
          width: 2,
          height: 80,
          displayValue: false,
        });
        const barcodeBase64 = canvas.toDataURL("image/png");

        const sender = sub?.sender?.[0] || {};
        const receiver = sub?.receiver?.[0] || {};

        const dateObj = new Date();
        const formattedDate = dateObj.toDateString();

        // Build full address with all fields
        const senderAddr = [
          sender.address,
          sender.city,
          sender.state,
          sender.country,
          sender.pincode,
        ]
          .filter(Boolean)
          .join(", ");

        const receiverAddr = [
          receiver.address,
          receiver.city,
          receiver.state,
          receiver.country,
          receiver.pincode,
        ]
          .filter(Boolean)
          .join(", ");

        // Get box dimensions for this label
        let dimensions = "N/A";
        let boxWeight = "N/A";
        if (expandedBoxes && expandedBoxes.length > index) {
          const box = expandedBoxes[index];
          dimensions = `${box.box_length || 0} X ${box.box_width || 0} X ${
            box.box_height || 0
          }`;
          boxWeight = box.box_weight || "N/A";
        }

        const invoiceNumbers =
          sub.invoices?.map((inv) => inv.invoice_number).join(", ") || "";

        // Get invoice for this label
        // const invoiceNumber = expandedInvoices[index] || 'N/A';

        htmlContent += `
        <div style="width:4in; height:6in; border:3px solid #000; margin:0 auto; background:#ffffff; box-sizing:border-box; font-family:Arial, Helvetica, sans-serif; padding:0; overflow:hidden;">
          <table style="width:100%; height:100%; border-collapse:collapse; table-layout:fixed; margin:0; padding:0;">
            <tbody>
              <!-- Row 1: MOVIN + Code -->
              <tr style="height:40px;">
              <td style="width:45%; border-right:3px solid #000; border-bottom:3px solid #000; text-align:center; vertical-align:middle; padding:4px 0;">
              <div style="display:flex; flex-direction:column; align-items:center; justify-content:center; height:100%;">
            
                <!-- Movein Logo -->
                <img
                  src="https://cdn.shiprath.com/images/movin3.svg"
                  style="height:50px; width:50px; object-fit:contain; margin-bottom:4px;"
                >
             </div>
            </td>
             </td>
                <td style="width:55%; border-bottom:3px solid #000; text-align:center; font-size:18px; font-weight:800; letter-spacing:1px; vertical-align:middle; padding:0;">${
                  sub.cnote || "KABLR3002"
                }</td>
              </tr>
              
              <!-- Row 2: Headers -->
              <tr style="height:22px;">
                <td style="border-right:2px solid #000; border-bottom:2px solid #000; text-align:center; font-size:12px; font-weight:800; vertical-align:middle; padding:0;">Sender Details</td>
                <td style="border-bottom:2px solid #000; text-align:center; font-size:12px; font-weight:800; vertical-align:middle; padding:0;">Receiver Details</td>
              </tr>
              
              <!-- Row 3: Sender/Receiver Content -->
              <tr style="height:100px;">
                <td style="border-right:2px solid #000; border-bottom:2px solid #000; padding:3px 6px; font-size:8.5px; line-height:1.4; vertical-align:top;">
                  <b>${sender.name || "N/A"}</b><br>
                  ${senderAddr || "N/A"}<br>
                  ${
                    sender.pincode
                      ? "Pincode: <b>" + sender.pincode + "</b>"
                      : ""
                  }<br>
                  ${sender.mobile ? "Phone: <b>" + sender.mobile + "</b>" : ""}
                </td>
                <td style="border-bottom:2px solid #000; padding:3px 6px; font-size:8.5px; line-height:1.4; vertical-align:top;">
                  <b>${receiver.name || "N/A"}</b><br>
                  ${receiverAddr || "N/A"}<br>
                  ${
                    receiver.pincode
                      ? "Pincode: <b>" + receiver.pincode + "</b>"
                      : ""
                  }<br>
                  ${
                    receiver.mobile
                      ? "Phone: <b>" + receiver.mobile + "</b>"
                      : ""
                  }
                </td>
              </tr>
              
              <!-- Row 4: Date/Type -->
              <tr style="height:25px;">
                <td style="border-right:2px solid #000; border-bottom:2px solid #000; padding:2px 6px; font-size:9px; vertical-align:middle;">
                  <b>Date:</b> ${
                    sub.order_date
                      ? new Date(sub.order_date).toDateString()
                      : formattedDate
                  }
                </td>
                <td style="border-bottom:2px solid #000; padding:2px 6px; font-size:9px; vertical-align:middle;">
                  <b>Type:</b> ${sub.type || "Forward"}
                </td>
              </tr>
              
              <!-- Row 5: Standard Premium -->
              <tr style="height:22px;">
                <td colspan="2" style="border-bottom:2px solid #000; text-align:center; font-size:13px; font-weight:800; vertical-align:middle; padding:0;">Standard Premium</td>
              </tr>
              
              <!-- Row 6: Barcode -->
              <tr style="height:60px;">
                <td colspan="2" style="border-bottom:2px solid #000; text-align:center; padding:2px 10px; vertical-align:middle;">
                  <img src="${barcodeBase64}" style="width:100%; height:100%; object-fit:contain;">
                </td>
              </tr>
              
              <!-- Row 7: Tracking Number -->
              <tr style="height:28px;">
                <td colspan="2" style="border-bottom:2px solid #000; text-align:center; font-size:16px; font-weight:800; letter-spacing:1px; vertical-align:middle; padding:0;">${barcode}</td>
              </tr>
              
              <!-- Rows 8-13: Details -->
              <tr style="height:18px;">
                <td style="border-right:2px solid #000; border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Pkg Wt: <b>${boxWeight}</b></td>
                <td style="border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Seq / Total: <b>${
                  index + 1
                } / ${totalPkgs}</b></td>
              </tr>
              <tr style="height:18px;">
                <td style="border-right:2px solid #000; border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Ship Wt: <b>${
                  sub.total_weight || sub.weight || "1"
                }</b></td>
                <td style="border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Shipment: <b>${
                  sub.carrier_tracking_number || barcode.substring(0, 13)
                }</b></td>
              </tr>
              <tr style="height:18px;">
                <td style="border-right:2px solid #000; border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Desc: ${
                  sub.order_description || sub.description || "N/A"
                }</td>
                <td style="border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Dimension: ${dimensions}</td>
              </tr>
              <tr style="height:18px;">
                <td style="border-right:2px solid #000; border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Payment: ${
                  sub.payment_mode.toUpperCase() || ""
                }</td>
                <td style="border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Cust Ref: <b>${
                  sub.order_number || sub.customer_ref || "N/A"
                }</b></td>
              </tr>
              <tr style="height:18px;">
                <td style="border-right:2px solid #000; border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Appt Start: ${
                  sub.appointment_start || ""
                }</td>
                <td style="border-bottom:1px solid #000; padding:1px 6px; font-size:8px;">Appt End: ${
                  sub.appointment_end || ""
                }</td>
              </tr>
              <tr style="height:18px;">
                <td style="border-right:2px solid #000; border-bottom:2px solid #000; padding:1px 6px; font-size:8px;">Invoice: <b>${invoiceNumbers}</b></td>
                <td style="border-bottom:2px solid #000; padding:1px 6px; font-size:8px;">PO: ${
                  sub.po_no || ""
                }</td>
              </tr>
              <tr>
              <td colspan="2" style="height:8px; border:none; padding:0;"></td>
            </tr>
            
            <tr style="height:22px;">
              <td colspan="2" style="padding:0 6px;">
                <div style="display:flex; justify-content:space-between; align-items:center;">
                  <span style="font-size:8px; font-weight:bold; color:#7a1f1f; text-transform:uppercase;">
                    AGGREGATOR - MOJOSHIP PRIVATE LIMITED
                  </span>
            
                  <img
                    src="../../img/logo_5.png"
                    style="height:46px; width:auto; object-fit:contain;"
                  />
                </div>
              </td>
            </tr>
             
              <!-- Row 14: T&C -->
              <tr>
                <td colspan="2" style="padding:3px 6px; font-size:7.5px; line-height:1.2; vertical-align:bottom; height:auto;">
                  <b>T&C:</b> By using our service, you agree to be bound by Terms of Carriage at www.movin.in.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        `;
      });
    });

    wrapper.innerHTML = htmlContent;
    document.body.appendChild(wrapper);

    const opt = {
      margin: 0,
      filename: "shipping-label.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
      },
      jsPDF: {
        unit: "in",
        format: [4, 6],
        orientation: "portrait",
      },
    };

    html2pdf()
      .set(opt)
      .from(wrapper)
      .save()
      .then(() => {
        document.body.removeChild(wrapper);
      })
      .catch((error) => {
        console.error("PDF generation error:", error);
        document.body.removeChild(wrapper);
      });
  };

  return null;
};

export default Movein_label;
